import React from "react";
import CmsCharacteristicsList from "../cms-characteristic-list";
import CmsComponentsStepsAndC2C from "../cms-component-steps-and-c2c";

function CmsModuleCharacteristicsAndSteps(props) {
  const { alias, cmsHandler, blockName, CmsAddElement, CmsEditableGroupIcons } =
    props;

  const cmsCharacteristics = props["cms-ml-characteristics-1"];
  const cmsStepsProps = props["cms-component-steps-list-1"];
  const cmsClickToCallProps = props["cms-component-click-to-call-1"];
  const cmsAlertProps = props["cms-ml-alert-1"];

  return (
    <div
      className="cms-module-characteristics-and-steps"
      data-cy="cms-module-characteristics-and-steps"
    >
      <div className="cms-module-characteristics-and-steps container">
        <CmsCharacteristicsList
          {...cmsCharacteristics}
          cmsHandler={cmsHandler}
          wrapElementsOnDivs={false}
          className="module-char-section-left"
          alias={alias}
          blockName={blockName}
          CmsAddElement={CmsAddElement}
          CmsEditableGroupIcons={CmsEditableGroupIcons}
        />
        <div className="banner-gap"></div>
        <CmsComponentsStepsAndC2C
          stepsProps={cmsStepsProps}
          c2cProps={cmsClickToCallProps}
          alertProps={cmsAlertProps}
          cmsHandler={cmsHandler}
          className="module-char-section-right"
          alias={alias}
          blockName={blockName}
          CmsAddElement={CmsAddElement}
          CmsEditableGroupIcons={CmsEditableGroupIcons}
        />
      </div>
      <style jsx>{`.cms-module-characteristics-and-steps {
  background-color: rgb(245, 245, 245);
  margin: 1.5rem 0;

  .main-characterisctics {
    gap: 0;
  }

  .cms-module-characteristics-and-steps {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    row-gap: 0.7rem;

    margin-bottom: 1rem;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .banner-gap {
    position: static;
    display: block;
    margin: 25px;
    height: 0;
    width: 85%;
    border: 1px solid #dddddd;
    opacity: 1;
  }
}

@media screen and (min-width: 768px) {
  .cms-module-characteristics-and-steps {
    .cms-module-characteristics-and-steps {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-flow: column;
      padding: 1rem;
      column-gap: 3rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      row-gap: 0.5rem;
      margin: 0 auto;

      :global(.module-char-section-left) {
        grid-column: 1;
      }

      :global(.module-char-section-right) {
        grid-column: 2;
      }

      .banner-gap {
        margin: 5px 20px;
        width: 1px;
        border: 1px solid #dddddd;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: calc(50% - 1.5rem);
        height: 85%;
        transform: translate(-50%, -50%);
      }
      .banner-right {
        width: 55%;
      }
    }
  }
}
`}</style>
    </div>
  );
}

export default CmsModuleCharacteristicsAndSteps;
